import React from 'react'
import './footer.css'

const Footer = () => {

  return (
    <footer role="contentinfo" className="footer">
      <a role="img" target="blank" aria-label="github link" href="https://github.com/huntertread" ><i className="fa fa-github" /></a>
      <a role="img" target="blank" aria-label="linkedin link" href="https://www.linkedin.com/in/huntertread/" ><i className="fa fa-linkedin" /></a>
    </footer>
  )
}

export default Footer